<script>
import { KINDS as RULE_KINDS } from 'frontend/client-communication-rules'

export default {
  name: 'EffectiveChannelDisplay',
  props: {
    clientCommunicationMessage: {
      type: Object,
      required: true,
    },
  },
  computed: {
    recipients() {
      if (!this.clientCommunicationMessage.sentToRecipient) {
        return []
      }
      if (this.clientCommunicationMessage.sentToRecipient?.includes(';')) {
        return this.clientCommunicationMessage.sentToRecipient
          .split(';')
          .map(recipient => recipient.trim())
      } else {
        return [this.clientCommunicationMessage.sentToRecipient]
      }
    },
    humanizedRuleKind() {
      return RULE_KINDS.find(el => el.value == this.clientCommunicationMessage.computedDeliveryKind)
        ?.label
    },
  },
}
</script>

<template lang="pug">
.d-flex.text-nowrap.align-items-baseline(v-if="clientCommunicationMessage.sentToRecipient")
  span.me-2 {{ humanizedRuleKind }}:
  template(v-for="(recipient, i) in recipients" :key="recipient")
    span.me-1(v-if="i > 0") ,
    email(v-if="clientCommunicationMessage.computedDeliveryKind == 'email'" :email="recipient")
    phone-number(
      v-else-if="clientCommunicationMessage.computedDeliveryKind == 'sms'"
      :phoneNumber="recipient"
    )
.d-flex(v-else)
  span.text-black-15 empty
</template>
<style lang="scss" scoped></style>
